export enum TableRefreshButtonEnum {
    UNKNOWN,
    GROUPS_LISTING_TABLE,
    GROUP_MEMBERS_TABLE,
    FEE_WAIVERS_TABLE,
    FEE_WAIVERS_BULK_EDIT,
}
